var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialogFace" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "840px",
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "titleDialog",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_c("p", [_vm._v("学生须知")]), _c("i")]
          ),
          _c(
            "div",
            { staticClass: "dataDialog" },
            [
              _c("div", { staticClass: "dataDialogDiv" }, [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.studentNotice) },
                }),
              ]),
              _c(
                "div",
                { staticClass: "radioDiv" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      attrs: { model: _vm.ruleForm, rules: _vm.rules },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "type" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.ruleForm.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "type", $$v)
                                },
                                expression: "ruleForm.type",
                              },
                            },
                            [
                              _c("el-checkbox", { attrs: { name: "type" } }, [
                                _c("span", { staticClass: "radioText" }, [
                                  _c("i", [_vm._v("*")]),
                                  _vm._v("我已阅读并同意该须知上的一切内容"),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [_vm._v("下一步，人脸识别")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }